// src/utility.js
import React from "react";
import { Box, List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import {
	Home as HomeIcon,
	AccountCircle as AccountCircleIcon,
	Settings as SettingsIcon,
	Logout as LogoutIcon,
	AccountCircle as ProfileIcon,
	Create as CreateIcon,
	Password as PasswordIcon,
} from "@mui/icons-material";
import logo from "../Malayan.png";
// import ChangePassword from '../component/ChangePassword';

// Function to convert Base64 to Blob
export const base64ToBlob = (base64, mimeType) => {
	const byteCharacters = atob(base64.split(",")[1]); // Decode Base64
	const byteNumbers = new Array(byteCharacters.length);
	for (let i = 0; i < byteCharacters.length; i++) {
		byteNumbers[i] = byteCharacters.charCodeAt(i);
	}
	const byteArray = new Uint8Array(byteNumbers);
	return new Blob([byteArray], { type: mimeType });
};

export function getDateComponents(date) {
	// Handle different input types
	const dateObj = date instanceof Date ? date : new Date(date);

	// Check if date is valid
	if (isNaN(dateObj.getTime())) {
		throw new Error("Invalid date provided");
	}

	const monthNames = [
		"January",
		"February",
		"March",
		"April",
		"May",
		"June",
		"July",
		"August",
		"September",
		"October",
		"November",
		"December",
	];

	return {
		day: String(dateObj.getDate()),
		month: monthNames[dateObj.getMonth()],
		year: dateObj.getFullYear(),
	};
}

export const printFormData = (formData) => {
	formData.forEach((value, key) => {
		console.log(`${key}:`, value);
	});
};

export const formatPhoneNumber = (phoneNumber) => {
	const countryCode = "+60";
	return phoneNumber.startsWith(countryCode)
		? phoneNumber.substring(countryCode.length)
		: phoneNumber;
};

export const formatDate = (dateString) => {
	const date = new Date(dateString);

	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, "0");
	const day = String(date.getDate()).padStart(2, "0");
	const hours = String(date.getHours()).padStart(2, "0");
	const minutes = String(date.getMinutes()).padStart(2, "0");
	const seconds = String(date.getSeconds()).padStart(2, "0");

	return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
};

export const getCurrentDate = () => {
	const date = new Date();
	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, "0");
	const day = String(date.getDate()).padStart(2, "0");

	return `${day}-${month}-${year}`;
};

export const formatDisplayDate = (input) => {
	// Handle already-formatted simple strings like 'DD-MM-YYYY' or 'YYYY-MM-DD'
	if (typeof input === "string") {
		// If it looks like DD/MM/YYYY or DD-MM-YYYY, return normalized with '-'
		const m1 = input.match(/^\s*(\d{1,2})[/-](\d{1,2})[/-](\d{4})\s*$/);
		if (m1) {
			const d = String(parseInt(m1[1], 10)).padStart(2, "0");
			const m = String(parseInt(m1[2], 10)).padStart(2, "0");
			const y = m1[3];
			return `${d}-${m}-${y}`;
		}
		// Fallback: try Date parsing
		const dObj = new Date(input);
		if (!isNaN(dObj.getTime())) {
			const y = dObj.getFullYear();
			const m = String(dObj.getMonth() + 1).padStart(2, "0");
			const d = String(dObj.getDate()).padStart(2, "0");
			return `${d}-${m}-${y}`;
		}
		return input; // Return as-is if unrecognized string
	}

	// Handle date-like objects { day, month, year }
	if (
		input &&
		typeof input === "object" &&
		Object.prototype.hasOwnProperty.call(input, "day") &&
		Object.prototype.hasOwnProperty.call(input, "month") &&
		Object.prototype.hasOwnProperty.call(input, "year")
	) {
		const d = String(input.day).padStart(2, "0");
		const m = String(input.month).padStart(2, "0");
		const y = String(input.year);
		return `${d}-${m}-${y}`;
	}

	// Handle Date objects
	if (input instanceof Date && !isNaN(input.getTime())) {
		const y = input.getFullYear();
		const m = String(input.getMonth() + 1).padStart(2, "0");
		const d = String(input.getDate()).padStart(2, "0");
		return `${d}-${m}-${y}`;
	}

	// Unknown input type; provide safe fallback
	try {
		return String(input ?? "");
	} catch {
		return "";
	}
};

export const toggleDrawer = (setDrawerOpen) => (open) => (event) => {
	if (
		event.type === "keydown" &&
		(event.key === "Tab" || event.key === "Shift")
	) {
		return;
	}
	setDrawerOpen(open);
};

export const sideMenuList = (toggleDrawer, handleMenuItemClick, role) => (
	<Box
		sx={{ width: 250 }}
		role="presentation"
		onClick={toggleDrawer(false)}
		onKeyDown={toggleDrawer(false)}
	>
		<Box sx={{ p: 2, textAlign: "center" }}>
			<img
				src={logo}
				alt="Logo"
				style={{ width: "100px", borderRadius: "50%" }}
			/>
		</Box>
		<List>
			{role === "SysAdmin" &&
				menuItemsSystemAdmin.map((item) => (
					<ListItem
						button
						key={item.text}
						onClick={() => handleMenuItemClick(item.text)}
					>
						<ListItemIcon>{item.icon}</ListItemIcon>
						<ListItemText primary={item.text} />
					</ListItem>
				))}
			{role === "Maker" &&
				menuItemsMaker.map((item) => (
					<ListItem
						button
						key={item.text}
						onClick={() => handleMenuItemClick(item.text)}
					>
						<ListItemIcon>{item.icon}</ListItemIcon>
						<ListItemText primary={item.text} />
					</ListItem>
				))}
			{role === "Manager" &&
				menuItemsManager.map((item) => (
					<ListItem
						button
						key={item.text}
						onClick={() => handleMenuItemClick(item.text)}
					>
						<ListItemIcon>{item.icon}</ListItemIcon>
						<ListItemText primary={item.text} />
					</ListItem>
				))}
			{role === "Adjuster" &&
				menuItemsAdjuster.map((item) => (
					<ListItem
						button
						key={item.text}
						onClick={() => handleMenuItemClick(item.text)}
					>
						<ListItemIcon>{item.icon}</ListItemIcon>
						<ListItemText primary={item.text} />
					</ListItem>
				))}
		</List>
	</Box>
);

export function generateBase64UUID() {
	return btoa(
		[...crypto.getRandomValues(new Uint8Array(16))]
			.map((b) => String.fromCharCode(b))
			.join(""),
	);
}

export const exportToCSV = (data, filename) => {
	if (!data || !data.length) return;

	const headers = Object.keys(data[0]);
	const csvContent = [
		headers.join(","), // header row
		...data.map((row) =>
			headers
				.map((header) => JSON.stringify(row[header] ?? ""))
				.join(","),
		),
	].join("\n");

	const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
	const url = URL.createObjectURL(blob);
	const link = document.createElement("a");
	link.setAttribute("href", url);
	link.setAttribute("download", `${filename}.csv`);
	link.click();
	URL.revokeObjectURL(url);
};

const menuItemsManager = [
	{ text: "My Assignments", icon: <HomeIcon /> },
	{ text: "Data Reports", icon: <SettingsIcon /> },
	{ text: "Change Password", icon: <PasswordIcon /> },
	{ text: "Profile", icon: <ProfileIcon /> },
	{ text: "Logout", icon: <LogoutIcon /> },
];

const menuItemsAdjuster = [
	{ text: "My Assignments", icon: <HomeIcon /> },
	{ text: "Change Password", icon: <PasswordIcon /> },
	{ text: "Profile", icon: <ProfileIcon /> },
	{ text: "Logout", icon: <LogoutIcon /> },
];

const menuItemsSystemAdmin = [
	{ text: "New Assignment", icon: <CreateIcon /> },
	{ text: "Create Users", icon: <AccountCircleIcon /> },
	{ text: "All Assignments", icon: <HomeIcon /> },
	{ text: "Data Reports", icon: <SettingsIcon /> },
	{ text: "Change Password", icon: <PasswordIcon /> },
	{ text: "Profile", icon: <ProfileIcon /> },
	{ text: "Logout", icon: <LogoutIcon /> },
];

const menuItemsMaker = [
	{ text: "New Assignment", icon: <CreateIcon /> },
	{ text: "My Assignments", icon: <HomeIcon /> },
	{ text: "Data Reports", icon: <SettingsIcon /> },
	{ text: "Change Password", icon: <PasswordIcon /> },
	{ text: "Profile", icon: <ProfileIcon /> },
	{ text: "Logout", icon: <LogoutIcon /> },
];

export const dataURLToBlob = (dataURL) => {
	const byteString = atob(dataURL.split(",")[1]);
	const mimeString = dataURL.split(",")[0].split(":")[1].split(";")[0];
	const ab = new ArrayBuffer(byteString.length);
	const ia = new Uint8Array(ab);
	for (let i = 0; i < byteString.length; i++) {
		ia[i] = byteString.charCodeAt(i);
	}
	return new Blob([ab], { type: mimeString });
};

// The policy is adequately insured when the value at risk does not exceed the sum insured;
// equality is adequate, since the average ratio is then 1.0 and nothing is prorated.
// Compared on cents so two figures that display as the same RM amount cannot disagree -
// e.g. 1000.1 * 75 is 75007.49999999999, which a raw compare calls short of 75007.50.
// A value at risk of zero (nothing entered yet) counts as adequate rather than warning
// about underinsurance on an empty form.
export const isSumInsuredAdequate = (sumInsured, valueAtRisk) => {
	const risk = Number(valueAtRisk) || 0;
	const insured = Number(sumInsured) || 0;
	if (risk <= 0) return true;
	return Math.round(risk * 100) <= Math.round(insured * 100);
};

// Trim transparent/white margins, center on a fixed-size canvas, preserve PNG transparency.
// Shared by every signature capture surface so the PDF gets consistently sized images
// whichever screen produced them.
export const processSignatureDataUrl = async (
	dataUrl,
	{
		padding = 20, // px – inner padding around the ink within the output canvas
		targetWidth = 400, // px – fixed output width; null to auto-calculate from targetHeight
		targetHeight = 150, // px – fixed output height
		alphaThreshold = 10, // treat alpha <= this as transparent
		whiteThreshold = 250, // RGB >= this considered white background
		background = null, // e.g., 'white' to force solid bg; null keeps transparency
	} = {},
) => {
	try {
		// Load image
		const img = await new Promise((resolve, reject) => {
			const i = new Image();
			i.onload = () => resolve(i);
			i.onerror = reject;
			i.src = dataUrl;
		});

		const srcW = Math.max(1, img.naturalWidth || img.width || 1);
		const srcH = Math.max(1, img.naturalHeight || img.height || 1);

		// Draw original to a source canvas
		const srcCanvas = document.createElement("canvas");
		srcCanvas.width = srcW;
		srcCanvas.height = srcH;
		const sctx = srcCanvas.getContext("2d");
		sctx.drawImage(img, 0, 0);

		let imageData;
		try {
			imageData = sctx.getImageData(0, 0, srcW, srcH);
		} catch (e) {
			return dataUrl;
		}

		const { data } = imageData;
		let minX = srcW,
			minY = srcH,
			maxX = -1,
			maxY = -1;
		for (let y = 0; y < srcH; y++) {
			for (let x = 0; x < srcW; x++) {
				const idx = (y * srcW + x) * 4;
				const r = data[idx];
				const g = data[idx + 1];
				const b = data[idx + 2];
				const a = data[idx + 3];
				const isOpaque = a > alphaThreshold; // any visible ink
				const isNotWhite =
					r < whiteThreshold ||
					g < whiteThreshold ||
					b < whiteThreshold;
				// Consider a pixel as content if it’s visible and not (near) white
				if (isOpaque && isNotWhite) {
					if (x < minX) minX = x;
					if (x > maxX) maxX = x;
					if (y < minY) minY = y;
					if (y > maxY) maxY = y;
				}
			}
		}

		// If no content detected, return original
		if (maxX < minX || maxY < minY) {
			return dataUrl;
		}

		const cropW = Math.max(1, maxX - minX + 1);
		const cropH = Math.max(1, maxY - minY + 1);

		// Fixed output canvas
		const outW =
			targetWidth ||
			Math.max(1, Math.round(cropW * (targetHeight / cropH)));
		const outH =
			targetHeight ||
			Math.max(1, Math.round(cropH * (targetWidth / cropW)));

		// Available drawing area inside the output canvas (after padding)
		const drawAreaW = Math.max(1, outW - padding * 2);
		const drawAreaH = Math.max(1, outH - padding * 2);

		// Scale the cropped content to fit within the draw area, preserving aspect ratio
		const cropAspect = cropW / cropH;
		const areaAspect = drawAreaW / drawAreaH;
		let scaledW, scaledH;
		if (cropAspect > areaAspect) {
			scaledW = drawAreaW;
			scaledH = Math.max(1, Math.round(drawAreaW / cropAspect));
		} else {
			scaledH = drawAreaH;
			scaledW = Math.max(1, Math.round(drawAreaH * cropAspect));
		}

		// Center the scaled content on the output canvas
		const offsetX = Math.round((outW - scaledW) / 2);
		const offsetY = Math.round((outH - scaledH) / 2);

		const outCanvas = document.createElement("canvas");
		outCanvas.width = outW;
		outCanvas.height = outH;
		const octx = outCanvas.getContext("2d");
		if (background) {
			octx.fillStyle = background;
			octx.fillRect(0, 0, outW, outH);
		}
		octx.imageSmoothingEnabled = true;
		octx.imageSmoothingQuality = "high";
		octx.drawImage(
			srcCanvas,
			minX,
			minY,
			cropW,
			cropH,
			offsetX,
			offsetY,
			scaledW,
			scaledH,
		);

		return outCanvas.toDataURL("image/png");
	} catch (_) {
		return dataUrl;
	}
};

export const convertToPng = async (imageData) => {
	return new Promise((resolve, reject) => {
		const img = new Image();
		img.crossOrigin = "anonymous"; // Handle CORS if necessary
		img.onload = () => {
			const canvas = document.createElement("canvas");
			canvas.width = img.width;
			canvas.height = img.height;
			const ctx = canvas.getContext("2d");
			ctx.drawImage(img, 0, 0);
			canvas.toBlob(
				(blob) => {
					if (blob) {
						resolve(blob);
					} else {
						reject(new Error("Failed to convert image to PNG"));
					}
				},
				"image/png", // Specify PNG format
			);
		};
		img.onerror = (error) => reject(error);
		img.src = imageData; // Set the source of the image
	});
};

export function numberToWords(num) {
	const ones = [
		"",
		"One",
		"Two",
		"Three",
		"Four",
		"Five",
		"Six",
		"Seven",
		"Eight",
		"Nine",
	];
	const teens = [
		"",
		"Eleven",
		"Twelve",
		"Thirteen",
		"Fourteen",
		"Fifteen",
		"Sixteen",
		"Seventeen",
		"Eighteen",
		"Nineteen",
	];
	const tens = [
		"",
		"Ten",
		"Twenty",
		"Thirty",
		"Forty",
		"Fifty",
		"Sixty",
		"Seventy",
		"Eighty",
		"Ninety",
	];
	const thousands = ["", "Thousand", "Million", "Billion"];

	if (num === null || num === undefined) return "";

	const value = Number(num);

	if (!Number.isFinite(value)) return "";

	// Avoid floating-point issues such as 3793.33 becoming 3793.329999...
	const roundedValue = Math.round(Math.abs(value) * 100) / 100;

	const ringgit = Math.floor(roundedValue);
	const sen = Math.round((roundedValue - ringgit) * 100);

	function helper(n) {
		let word = "";

		if (n < 10) {
			word = ones[n];
		} else if (n < 20 && n > 10) {
			word = teens[n - 10];
		} else if (n < 100) {
			word =
				tens[Math.floor(n / 10)] +
				(n % 10 !== 0 ? " " + ones[n % 10] : "");
		} else {
			word =
				ones[Math.floor(n / 100)] +
				" Hundred" +
				(n % 100 !== 0 ? " " + helper(n % 100) : "");
		}

		return word;
	}

	function wholeNumberToWords(number) {
		if (number === 0) return "Zero";

		let word = "";
		let chunkCount = 0;

		while (number > 0) {
			const chunk = number % 1000;

			if (chunk !== 0) {
				word =
					helper(chunk) +
					(thousands[chunkCount] ? " " + thousands[chunkCount] : "") +
					(word ? " " + word : "");
			}

			number = Math.floor(number / 1000);
			chunkCount++;
		}

		return word.trim();
	}

	let result = `${wholeNumberToWords(ringgit)} Ringgit Malaysia`;

	if (sen > 0) {
		result += ` and ${wholeNumberToWords(sen)} Sen`;
	}

	return `${result} Only`;
}
